export const prepareStatusClass = (value: string) => {
  switch (value) {
    case 'Заказ выполнен':
      return 'success';
    case 'Выполнен':
      return 'success';
    case 'Принят без расхождений':
      return 'success';
    case 'Частично выполнен':
      return 'warning';
    case 'Принят с расхождениями':
      return 'warning';
    case 'Не выполнен':
      return 'error';
    case 'В пути':
      return 'onWay';
    case 'Размещен':
      return 'posted';
    case 'internal':
      return 'onWay';
    case 'mp_return':
      return 'error';
  }
};
